export const WILDCARD = Symbol("*");
